import { Box, Flex } from '@chakra-ui/react'
import type { DailyEventObjectLocalAudioLevel } from '@daily-co/daily-js'
import {
  useAudioTrack,
  useDaily,
  useLocalSessionId
} from '@daily-co/daily-react'
import { times } from 'lodash'
import React, { useEffect, useRef, useState } from 'react'

export const DailyCompactAudioLevel = () => {
  const localId = useLocalSessionId()
  const callObject = useDaily()
  const [audioLevel, setAudioLevel] = useState<number>(0)
  const numBars = 15
  const observerActiveRef = useRef(false)
  const audioLevelCallbackRef = useRef<
    (event: DailyEventObjectLocalAudioLevel) => void
  >(event => {})

  const micTrack = useAudioTrack(localId)
  const isMuted = micTrack.isOff

  const handleVolumeChange = (volume: number) => {
    if (volume && volume > 0.005) {
      setAudioLevel(Math.min(volume * 6, 0.99))
    } else {
      setAudioLevel(0)
    }
  }

  // Manually manage the observer lifecycle to prevent duplicate observers
  useEffect(() => {
    if (!callObject || !localId || observerActiveRef.current) return

    audioLevelCallbackRef.current = (event: DailyEventObjectLocalAudioLevel) =>
      handleVolumeChange(event.audioLevel)

    callObject.on('local-audio-level', audioLevelCallbackRef.current)
    callObject.startLocalAudioLevelObserver(100)
    observerActiveRef.current = true

    return () => {
      if (callObject && observerActiveRef.current) {
        callObject.off('local-audio-level', audioLevelCallbackRef.current)
        callObject.stopLocalAudioLevelObserver()
        observerActiveRef.current = false
      }
    }
  }, [callObject, localId])

  return (
    <Flex ml="8px">
      {times(numBars, i => (
        <Box
          key={i}
          h="16px"
          w="2.5px"
          borderRadius="4px"
          bg={
            audioLevel >= (i + 1) * (1 / numBars) && !isMuted
              ? '#68E19F'
              : '#E4E5E6'
          }
          mr="2px"
        />
      ))}
    </Flex>
  )
}
